import { render, staticRenderFns } from "./baseHead.vue?vue&type=template&id=2cf86bea"
import script from "./baseHead.vue?vue&type=script&lang=js"
export * from "./baseHead.vue?vue&type=script&lang=js"
import style0 from "./baseHead.vue?vue&type=style&index=0&id=2cf86bea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports